import { Module } from '@nestjs/common';
import { CodeListMainController } from './code-list-main.controller';
import { CodeListMain } from './code-list-main.entity';
import { CodeListMainService } from './code-list-main.service';
import { TypeOrmModule } from '@nestjs/typeorm';
import { CodeListMainAdapter } from './dto/code-list-main.adapter';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { CodeListMainItems } from './code-list-main-items.entity';
import {  SkuService } from '@gtpl/shared-services/masters';
import { CodeListLog } from './code-list-log.entity';
import { CodeListlogRepository } from './repositories/code-list-log.repository';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { CodeListLogAdapter } from './dto/code-list-log.adapter';
import { QcClearanceInfo } from '../qc-clearance-info/qc-clearance_info.entity';

@Module({
  imports:[TypeOrmModule.forFeature([CodeListMain,CodeListMainItems,CodeListLog,QcClearanceInfo])],
  controllers: [CodeListMainController],
  providers: [CodeListMainService,CodeListMainAdapter,ApplicationExceptionHandler,SkuService,CodeListlogRepository,SaleOrderService,CodeListLogAdapter]
})
export class CodeListMainModule {}
